module.exports = __webpack_public_path__ + "static/media/LogoBlack.90e46243.png";